<template>
	<div>
		<label class="label-form">{{labelText}}</label>
		<v-select
			bottom
			single-line
			hide-details
			class="filter-select filter-select-indicator"
			v-bind="$attrs"
			:items="typeDocuments"
			item-text="name"
			item-value="id"
			v-model="documentType"
		>
		</v-select>
		<v-text-field
			class="input-border-inset input-form-select"
			v-bind="$attrs"
			@blur="searchCustomer"
			@keyup.enter="searchCustomer"
			@input="typeDocumentType"
			v-model="numDocument"
		>
		</v-text-field>
		<p class="caption red--text"
			v-if="$v.documentType.$invalid">
				El tipo de Identificación es requerido
		</p>
		<p class="caption red--text text-caption"
			v-if="$v.numDocument.$invalid">
				Numero de Documento es requerido
		</p>
	</div>
</template>

<script>
import { required, minValue, maxLength, minLength } from 'vuelidate/lib/validators';
import mixins from '@/shared/mixins';

async function created() {
	const { data: response } = await this.$http.get(`${process.env.PMS_URL}/documents-type`);
	this.typeDocuments = [...response.data];
}

function numDocumentLength() {
	if (this.documentType === 1) {
		return 8;
	} else if (this.documentType === 4) {
		return 11;
	}
	return 0;
}

function typeDocumentType() {
	this.$emit('customerDetail', this.numDocument);
}

async function searchCustomer() {
	if (this.search) {
		let customer = {};
		if (this.numDocument !== '') {
			if (this.documentType === 4) {
				try {
					const url = `${process.env.PMS_URL}/customer-search`;
					const params = {
						numDocument: this.numDocument,
						documentType: this.documentType,
					};
					(
						{ data: customer } = await this.$http.get(url, { params })
					);
				} catch (error) {
					customer = {};
					this.showNotification('La empresa no se encuentra registrada como cliente', 'warning');
				}
			}
			try {
				if (!customer.data) {
					(
						{ data: customer } = await this.mixinSearchCustomer(
							this.documentType,
							this.numDocument,
						)
					);
				}
				if (customer.data) {
					this.showNotification('Cliente conseguido !', 'success');
					this.$emit('customer-data', customer);
				}
			} catch (error) {
				if (this.documentType === 4) {
					this.showNotification('La empresa no se encuentra registrada como cliente', 'warning');
				} else {
					this.showNotification('La persona no se encuentra registrada como cliente', 'warning');
				}
				this.$emit(
					'customer-not-found',
					{ numDocument: this.numDocument, documentType: this.documentType },
				);
			}
		}
	}
}

function value(newValue) {
	if (newValue) {
		this.numDocument = newValue.numDocument || '';
		this.documentType = newValue.documentType || '';
	} else {
		this.numDocument = '';
		this.documentType = '';
	}
}

function numDocument(newValue) {
	if (!this.search) {
		this.$emit(
			'input',
			{ numDocument: newValue, documentType: this.documentType },
		);
	}
}

function documentType(newValue) {
	if (!this.search) {
		this.$emit(
			'input',
			{ numDocument: this.numDocument, documentType: newValue },
		);
	}
}

function data() {
	return {
		typeDocuments: [],
		numDocument: '',
		documentType: '',
	};
}

function validations() {
	const newNumDocument = {
		required,
	};
	if (this.numDocumentLength > 0) {
		newNumDocument.maxLength = maxLength(this.numDocumentLength);
		newNumDocument.minLength = minLength(this.numDocumentLength);
	}
	return {
		numDocument: newNumDocument,
		documentType: {
			minValue: minValue(1),
			required,
		},
	};
}

export default {
	name: 'type-document-input',
	created,
	data,
	validations,
	inheritAttrs: false,
	computed: {
		numDocumentLength,
	},
	methods: {
		typeDocumentType,
		searchCustomer,
	},
	mixins,
	props: {
		labelText: {
			default: '',
			type: String,
		},
		subsidiary: {
			default: 0,
			type: Number,
		},
		search: {
			default: true,
			type: Boolean,
		},
		value: null,
	},
	watch: {
		documentType,
		numDocument,
		value,
	},
};
</script>

<style lang="scss" scoped>
	.text-caption {
		margin-bottom: 0;
	}
</style>




// WEBPACK FOOTER //
// type-document-input.vue?68b65a2c